
export default function carousel (wrapSelector, options) {
    var EFFECT = {
      SLIDE: 'slide',
      FADEIN: 'fadein'
    };
    options = options || {};
    options = {
      effect: options.effect || EFFECT.SLIDE,   // slide | fadein， fadein模式暂不支持
      activeClass: options.activeClass || '',    // fadein时当前图片项的class
      interval: options.interval || 15,    //每15毫秒移动指定的setp步长
      step: options.step || 30,  //步长
      rest: options.rest || 2000,    //每休息多长时间播放一次
      callback: options.callback || function () {}  //每次切换后的回调
    };
    //1. 找对象
    var box=document.querySelector(wrapSelector);
    // var screen = box.querySelector(".carousel-pics");
    var ul = box.querySelector(".carousel-pics");
    var ullis = ul.getElementsByTagName('li');    
    var ol = box.querySelector(".carousel-pagin");
    // var arr = document.querySelector("#arr");
    // var leftArr = arr.querySelector(".left");
    // var rightArr=arr.querySelector(".right");
    var imgwidth=ul.offsetWidth;
    var pic = 0, fk =0;
    var timer;

    // 动态分页
    //根据ul中li的个数创建小方块
    var paginHtml = []
    for(let i = 0; i < ullis.length; i++){
      paginHtml.push('<li>' + (i+1)+ '</li>')
    }
    ol.innerHTML = paginHtml.join('');
    var ollis=ol.getElementsByTagName('li');
    ollis[0].className="current";

    var callback = function (index) {
      options.callback(index === ullis.length - 1 ? 0 : index)
    };

    callback(pic)
    //低于1张图片时，不轮播
    if(ullis.length <= 1) { return; }
    

    // 创建假图片
    // 克隆ul下的第一个li
    // 重新获取ullis
    var cloneli = ullis[0].cloneNode(true);
    ul.appendChild(cloneli);
    ullis = ul.getElementsByTagName('li');

    switch (options.effect) {
      case EFFECT.SLIDE: 
        ul.style.width = imgwidth * ullis.length + 'px';
        // 每个图片项都绝对定位
        for(let i = 0;i < ullis.length;i++){
          ullis[i].style.float = 'left';
        }
        break;
      case EFFECT.FADEIN:
        ul.style.position = 'relative';
        // 每个图片项都绝对定位
        for(let i = 0;i < ullis.length;i++){
          ullis[i].style.position = 'absolute';
        }
        break
      default:
    }

    

    
    // 给小方块注册点击事件
    for(var i=0;i<ollis.length;i++){
      ollis[i].index=i;//存索引
      ollis[i].addEventListener("click", function(){
        //3.2 小方块高亮排他
        for(var i=0;i<ollis.length;i++){
          ollis[i].className="";
        }
        this.className="current";
        //3.3. 移动ul
        if(timer) {
          clearTimeout(timer)
        } 
        var target=-this.index*imgwidth;
        slideItem(ul,target);
        pic= fk = this.index;
      })
    }

    //4. 左右焦点功能（无缝）
    //4.1 鼠标经过盒子，显示箭头
    // box.onmouseover=function(){
    //   arr.style.display="block";
    //   //清除定时器
    //   clearInterval(timer);
    // }
    //4.2 鼠标离开盒子，隐藏箭头
    // box.onmouseleave=function(){
    //   arr.style.display="none";
    //   timer=setInterval(function(){
    //     rightArr.onclick();
    //   },1000)
    // }
    var play = function () {
      fk++;
      if(fk === ollis.length){
        fk=0;
      }
      for(var i=0;i<ollis.length;i++){
        ollis[i].className="";
      }
      ollis[fk].className="current";

      switch (options.effect) {
        case EFFECT.SLIDE: 
          //如果已经到了最后一张假图片，让ul瞬移到第一张真图片
          if(pic === ollis.length){
            ul.style.marginLeft = 0 + 'px';
            pic=0;
          }
          pic++;//记录出去的图片张数
          slideItem(ul,-pic*imgwidth);
          break;
        case EFFECT.FADEIN:
          
          break
        default:
      }
      
    }
    // 移动项目
    var slideItem = function (element, target) {
      if(element.timer) {
        //如果有值，说明已经开启过定时器
        clearInterval(element.timer);
      }
      
      element.timer = setInterval(function () {
        var curMarginLeft = element.style.marginLeft.replace('px', '') * 1
        //leader = leader + step
        if(curMarginLeft > target) {
          var distance = options.step > Math.abs(target) - Math.abs(curMarginLeft) ? Math.abs(target) - Math.abs(curMarginLeft) : options.step;
          element.style.marginLeft = curMarginLeft - distance + 'px';
        } else {
          element.style.marginLeft = target + 'px';
          clearInterval(element.timer);
          callback(pic)
          timer = window.setTimeout(play, options.rest)
        }
        //如果步数是9的话，永远都跑不到重点
        //如果到达终点的距离已经小于一步了，就不跑了，因为你再跑就过了。
        
      }, options.interval);
    };

    // var fadeIn = function (element, target) {
      
    // };
    
    //5. 自动播放的功能
    timer= setTimeout(play, options.rest)
    //6. 同步问题
    //6.1 点击右箭头,同步
    //6.2 点击左箭头，同步
    //6.3 点击小方块，同步
  }
